import * as actionTypes from '../Actions/ActionTypes';
import { updateObject } from '../../Helpers/Utility';

const initialState = {
    token: null,
    userId: null,
    isAdmin: null,
    environments: null,
    isSessionValid: null,
    error: null,
    loading: false,
    defaultEnvironment:null,
    fullscreentoggle:false
};

const authStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
};

const authSuccess = (state, action) => {
    return updateObject(state, {
        token: action.token,
        userId: action.userId,
        isAdmin: action.isAdmin,
        environments: action.environments,
        isSessionValid: action.isSessionValid,
        defaultEnvironment:action.defaultEnvironment
    });
};

const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    // console.log("Reducer AuthLogout");
    return updateObject(state, { userId: null, token: null, isAdmin: null,environments:null, isSessionValid: false,defaultEnvironment:null,error:null });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}

const reducer = (state = initialState, action) => {
    // console.log("Reducer Called: " + action.type);
    switch (action.type) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action);
        
        default:
            return state;
    }
};

export default reducer;